// @ts-check
import React from "react"
import { gfm, gfmHtml } from "micromark-extension-gfm"
import { micromark } from "micromark"

/**
 * @typedef {object} AssistantMarkdownProps
 * @property {string} content
 * @property {string} [className]
 */

/**
 * @param {AssistantMarkdownProps} props
 */
export default function AssistantMarkdown({ content, className }) {
  const html = micromark(content || "", {
    extensions: [gfm()],
    htmlExtensions: [gfmHtml()],
  })

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
